import axios from "axios";
// import store from '../store';,
function errorHandler(error, reject) {
  console.log(error);
  if (error.response && error.response.data) {
    reject(error.response.data);
  } else {
    reject(error);
  }
}

export default {
  aging(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "account",
          "namaacc",
          "tgl2",
          "exclude",
          "cashBasis",
          "excludezero",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/aging${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  agingexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "account",
          "namaacc",
          "tgl2",
          "exclude",
          "cashBasis",
          "excludezero",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/agingexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `ar_aging_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  agingprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "account",
          "namaacc",
          "tgl2",
          "exclude",
          "cashBasis",
          "excludezero",
          "view",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/agingprint${str}`;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  agingrekapcust(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl2", "exclude", "excludezero"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/agingrekapcust${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  agingrekapcustexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl2", "exclude", "excludezero"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/agingrekapcustexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `summary_ar_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  agingrekapcustprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "account",
          "namaacc",
          "tgl2",
          "exclude",
          "excludezero",
          "view",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/agingrekapcustprint${str}`;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },

  agingkolektor(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl2", "exclude", "excludezero"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/agingkolektor${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  agingkolektorexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl2", "exclude", "excludezero"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/agingkolektorexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `ar_aging_collector_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  agingkolektorprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "account",
          "namaacc",
          "tgl2",
          "exclude",
          "excludezero",
          "view",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/agingkolektorprint${str}`;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  agingkolektorrekapcust(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl2", "exclude", "excludezero"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/agingkolektorrekapcust${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  agingkolektorrekapcustexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl2", "exclude", "excludezero"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/agingkolektorrekapcustexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `summary_ar_collector_${obj.tgl2}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  agingkolektorrekapcustprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "account",
          "namaacc",
          "tgl2",
          "exclude",
          "excludezero",
          "view",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/agingkolektorrekapcustprint${str}`;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },

  agingselisih(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl2", "exclude", "excludezero"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/agingselisih${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  agingselisihexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl2", "exclude", "excludezero"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/agingselisihexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `ar_aging_selisih_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },

  currency() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/currency/cbo");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  defferedAccount() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/arinv/defferedaccount");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  postgroup() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/arinv/postgroup");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  postgroupnonkoran() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/arinv/postgroupnonkoran");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  salesAccount() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/arinv/salesaccount");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  saveCancelReissue(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.post("/arinv/savecancelreissue", obj);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  unearnedAccount() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/arinv/unearnedaccount");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rekondb(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/rekondb${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rekondbexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/rekondbexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `ar_rekon_DB_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rekonkr(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/rekonkr${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rekonkrexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/rekonkrexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `ar_rekon_CR_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },

  rekondeffereddb(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/rekondeffereddb${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rekondeffereddbexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/rekondeffereddbexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Inv_UnEarned_DB_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rekondefferedkr(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/rekondefferedkr${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rekondefferedkrexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/rekondefferedkrexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Inv_UnEarned_CR_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },

  rekonsales(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/rekonsales${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rekonsalesexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/rekonsalesexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `sales_rekon_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },

  rptsales(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/rptsales${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rptsalesbyae(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "salesae_id",
          "SalesExCode",
          "salesae_name",
          "tgl1",
          "tgl2",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/rptsalesbyae${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rptsalesbyaegroup(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const response = await axios({
          url: `/arreport/rptsalesbyaegroup${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        resolve(response);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  rptsalesUnpaid(obj = {}) {
    obj.modeGet = "view";
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "unpaid",
          "kodeacc",
          "namaacc",
          "tgl1",
          "tgl2",
          "modeGet",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const url = `/arreport/rptsales-ar-unpaid${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  billingCommitDelivered(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["customer_id", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/billingCommitDelivered${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rptsalesexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/rptsalesexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `sales_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rptsalesbyaeexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "salesae_id",
          "SalesExCode",
          "salesae_name",
          "tgl1",
          "tgl2",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/rptsalesbyaeexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `sales_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rptsalesUnpaidexport(obj = {}) {
    obj.modeGet = "exportxls";
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "unpaid",
          "kodeacc",
          "namaacc",
          "tgl1",
          "tgl2",
          "modeGet",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/rptsales-ar-unpaid${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `sales_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },

  rekonpbbdb(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/rekonunearndb${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rekonpbbdbexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/rekonunearndbexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `PBB_Debit_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rekonpbbkr(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/rekonunearnkr${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rekonpbbkrexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/rekonunearnkrexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `PBB_Credit_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },

  trxcustomer(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "customer",
          "customer_id",
          "custinfo",
          "matauang",
          "tgl2",
          "alltrx",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/trxcustomer${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  trxcustomerexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "customer",
          "customer_id",
          "custinfo",
          "matauang",
          "tgl2",
          "alltrx",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/trxcustomerexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `ar_trx_customer_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  trxcustomerprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["customer", "custinfo", "matauang", "tgl2", "alltrx"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/trxcustomerprint${str}`;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  pbblist(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/pbblist${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  pbblistexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/pbblistexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `PBB_List_${obj.tgl1}_sd_${obj.tgl2}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  pbbsmry(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/pbbsmry${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  pbbsmryexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/pbbsmryexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `PBB_saldo_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  unearnbalance(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/defferedbalance${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  unearnbalanceexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/defferedbalanceexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `UnEarn_saldo_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  unearnsmry(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl2", "alltrx"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/defferedsmry${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  unearnsmryexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["account", "namaacc", "tgl2", "alltrx"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/arreport/defferedsmryexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `UnEarn_saldo_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  eliminatecancel(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/arreport/eliminatecancel`;
        const { data } = await axios.post(url, obj);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  eliminatecancelPreview(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ['tgl1', 'tgl2', 'previewOnly'];
        let str = '';
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key] !== undefined && obj[key] !== '') {
            str += str ? '&' : '?';
            str += key + '=' + encodeURIComponent(obj[key]);
          }
        }
        const url = `/arreport/eliminatecancel${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
};
